import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

function Difficulty({ difficulty }): React.ReactElement {
  const difficultyLevel = difficulty
    ? new Array(Math.floor(difficulty)).fill('*')
    : [];
  // console.log(difficulty, difficultyLevel);
  return difficulty ? (
    <div>
      <div className="font-serif tracking-widest text-light">
        Difficulty Index :
      </div>
      <div className="mt-2 mr-2">
        {difficulty === 6 ? (
          <span className="font-serif text-2xl font-bold tracking-widest text-highlight-ochre">
            EXTREME
          </span>
        ) : (
          difficultyLevel.map((item, index) => (
            <span key={index}>
              <StaticImage
                src="../../images/lock.png"
                alt="difficulty"
                width={25}
              />
            </span>
          ))
        )}
        {/* {difficultyLevel.map((item, index) => (
          <span key={index}>
            <StaticImage
              src="../../images/lock.png"
              alt="difficulty"
              width={25}
            />
          </span>
        ))} */}
        {difficulty % 1 ? (
          <StaticImage
            src="../../images/lock-half.png"
            alt="difficulty"
            width={30}
          />
        ) : (
          ''
        )}
        {difficulty === 3 ? (
          <span className="inline-block">
            <StaticImage
              src="../../images/lock-half.png"
              alt="difficulty"
              width={30}
            />
            <StaticImage
              src="../../images/lock-half.png"
              alt="difficulty"
              width={30}
            />
          </span>
        ) : (
          ''
        )}
      </div>
    </div>
  ) : (
    <></>
  );
}

export { Difficulty };
